import {NgModule} from '@angular/core';
import {RouterModule} from "@angular/router";
import {ORDER_HISTORY_ROUTES} from "./order-history.routes";

@NgModule({
    imports: [
        RouterModule.forChild(ORDER_HISTORY_ROUTES),
    ],
    exports: [
        RouterModule
    ]
})
export class OrderHistoryRoutingModule { }
